import { onBeforeUnmount, onMounted, watch } from 'vue'

const classRequestCounts = new Map()

const isEnabled = (value) => value === true || value === 1 || value === '1'

const updateBodyClass = (className, shouldEnable, state) => {
  if (typeof document === 'undefined') return

  const currentCount = classRequestCounts.get(className) || 0
  let nextCount = currentCount

  if (shouldEnable && !state.requested) {
    state.requested = true
    nextCount += 1
  } else if (!shouldEnable && state.requested) {
    state.requested = false
    nextCount = Math.max(0, nextCount - 1)
  }

  if (nextCount > 0) classRequestCounts.set(className, nextCount)
  else classRequestCounts.delete(className)

  document.body.classList.toggle(className, nextCount > 0)
}

const useFooterBackgroundClass = (className, valueGetter) => {
  const state = {
    mounted: false,
    requested: false,
  }

  watch(valueGetter, (value) => {
    if (!state.mounted) return
    updateBodyClass(className, isEnabled(value), state)
  })

  onMounted(() => {
    state.mounted = true
    updateBodyClass(className, isEnabled(valueGetter()), state)
  })

  onBeforeUnmount(() => {
    state.mounted = false
    updateBodyClass(className, false, state)
  })
}

export default useFooterBackgroundClass
